



























// @ is an alias to /src
import EditForm from '@/modules/core/components/EditForm.vue';
import { agencyApi } from '../agency.api';
import { debounce } from '@/modules/core/decorators/debounce';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { AgencyFormModel } from '../agency.form-model';
import { plainToClass } from 'class-transformer';
import EditFormClass from '@/modules/core/components/EditForm';

@Component({
  components: {
    EditForm,
  },
})
export default class AgencyEdit extends EditFormClass {
  public isLabelAvailable = true;
  public originalLabel = '';
  public isCodeAvailable = true;
  public originalCode = '';
  public formModel = new AgencyFormModel();
  public entityCreatedMsg = 'Agence créée';
  public entityUpdatedMsg = 'Agence mise à jour';
  public formModelClass = AgencyFormModel;
  public api = agencyApi;

  @Prop({
    default: null,
  })
  public agencyId!: string;

  @Prop({
    default: null,
  })
  public agency!: any;

  public get cardTitle(): string {
    return this.creation
      ? 'Nouvelle agence'
      : `Edition de l'agence ${this.originalLabel}`;
  }

  public get entityId(): string {
    return this.agencyId;
  }

  public get creation(): boolean {
    return !this.agency && !this.agencyId;
  }

  public get saveLabel(): string {
    return this.creation ? 'Créer' : 'Enregistrer';
  }

  @debounce(300)
  public onLabelChange(): void {
    this.formModel.validateField('label');
  }

  @debounce(300)
  public onCodeChange(): void {
    this.formModel.validateField('code');
  }

  public async checkLabelAvailability(): Promise<boolean> {
    if (this.formModel.label) {
      const labelAvailable = await agencyApi.isLabelAvailable(
        this.formModel.label,
      );

      this.isLabelAvailable =
        labelAvailable || this.originalLabel === this.formModel.label;
    }

    return this.isLabelAvailable;
  }

  public async checkCodeAvailability(): Promise<boolean> {
    if (this.formModel.code) {
      const codeAvailable = await agencyApi.isCodeAvailable(
        this.formModel.code,
      );

      this.isCodeAvailable =
        codeAvailable || this.originalCode === this.formModel.code;
    }

    return this.isCodeAvailable;
  }

  @Watch('agencyId', { immediate: true })
  public onAgencyIdChange(newVal: string): void {
    if (newVal) {
      this.getEntity();
    } else {
      this.fetchedEntity = null;
    }
  }

  @Watch('formModel', { immediate: true })
  public onAgencyChange(): void {
    this.originalLabel = this.formModel.label;
    this.originalCode = this.formModel.code;
  }

  @Watch('agency', { immediate: true })
  public onAgencyPropChange(): void {
    if (this.agency) {
      this.formModel = plainToClass(AgencyFormModel, this.agency);
      this.formModel.original = this.agency;
    }
  }
}
